export const APP_REFRESH_EVENT = "sm-app-refresh";

export function notifyAppRefresh(): void {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(new CustomEvent(APP_REFRESH_EVENT));
  } catch {
    /* ignore */
  }
}
